export default __webpack_public_path__ + "static/media/pptx.05f670cf.svg";